import {
	ModalBody,
} from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { OverarchingAssetType } from '../AssetOverview.types'

import { OverarchingAssetTypeConst } from '../AssetOverview.types'
import { PrimaryButton, SecondaryButton } from '@monthio/design-system'

const ModalBodyWrapper = styled(ModalBody)`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const AddCarsButton = styled(PrimaryButton)`
	margin: 15px;
	width: 300px;
`
const ContinueButton = styled(SecondaryButton)`
	margin: 15px;
	width: 300px;
`

interface MissingAssetsPromptProps {
	error: string
	handleContinue: () => Promise<void>
	handleAddAssets: (assetType: OverarchingAssetType | undefined) => void
}

export const MissingAssetsPrompt = ({
	error,
	handleContinue,
	handleAddAssets,
}: MissingAssetsPromptProps) => {
	const { t } = useTranslation()

	const assetType =
		error === 'ExpenseObjectsNoCarsButCarRelatedExpenses'
			? OverarchingAssetTypeConst.Vehicle
			: undefined

	return (
		<ModalBodyWrapper>
			<span>{t(`assetOverview-missingAssetsPrompt-${error}-description`)}</span>
			<div>
				<AddCarsButton onClick={() => handleAddAssets(assetType)}>
					{t('assetOverview-missingAssetsPrompt-addAssets-button')}
				</AddCarsButton>
				<ContinueButton onClick={handleContinue}>
					{t('assetOverview-missingAssetsPrompt-continue')}
				</ContinueButton>
			</div>
		</ModalBodyWrapper>
	)
}
